var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("el-cascader", {
    ref: "relCategory",
    attrs: {
      placeholder: "请选择品类",
      options: _vm.categoryList,
      filterable: "",
      props: _vm.defaultProps,
      "change-on-select": "",
      clearable: "",
      "show-all-levels": false
    },
    on: { change: _vm.changeAddress },
    model: {
      value: _vm.categoryValue,
      callback: function($$v) {
        _vm.categoryValue = $$v
      },
      expression: "categoryValue"
    }
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }